import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgCircle = function SvgCircle(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 75 75"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_1_47)",
        d: "m70.084 18.906-1.618-2.84a1.663 1.663 0 0 0-2.624-.35l-3.72 3.717a1.67 1.67 0 0 0-.208 2.107 29.175 29.175 0 0 1-11.096 41.936 29.2 29.2 0 0 1-13.318 3.22 28.9 28.9 0 0 1-13.675-3.394l6.294-6.296a20.85 20.85 0 0 0 22.75-5.425 20.84 20.84 0 0 0 3.386-23.138 1.666 1.666 0 0 0-2.683-.456l-3.766 3.74a1.66 1.66 0 0 0-.444 1.56l.324 1.352a12.495 12.495 0 0 1-11.4 15.332c-2.43.15-4.85-.413-6.963-1.619l-1.66-.951a1.66 1.66 0 0 0-2.006.269L12.283 63.036a1.663 1.663 0 0 0 .165 2.501l2.265 1.737A37.17 37.17 0 0 0 37.513 75a37.54 37.54 0 0 0 32.413-18.686 37.52 37.52 0 0 0 .158-37.408"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1_47)",
        d: "M60.306 7.729A37.16 37.16 0 0 0 37.506 0 37.54 37.54 0 0 0 5.074 18.686a37.52 37.52 0 0 0-.15 37.424l1.619 2.837a1.67 1.67 0 0 0 2.627.353l3.715-3.714a1.68 1.68 0 0 0 .207-2.103 29.175 29.175 0 0 1 11.096-41.936 29.2 29.2 0 0 1 13.318-3.22 28.9 28.9 0 0 1 13.672 3.404l-6.297 6.292a20.84 20.84 0 0 0-25.836 9.803 20.8 20.8 0 0 0-2.384 9.682c0 .346.094 1.925.123 2.197a21 21 0 0 0 1.964 6.88 1.67 1.67 0 0 0 2.686.457l3.766-3.769a1.67 1.67 0 0 0 .447-1.556l-.324-1.355a12.49 12.49 0 0 1 11.4-15.333c2.43-.149 4.85.415 6.964 1.622l1.66.951a1.67 1.67 0 0 0 2.006-.268l15.37-15.367a1.672 1.672 0 0 0-.162-2.504z"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1_47",
        x1: 24.275,
        x2: 77.072,
        y1: 77.4,
        y2: 24.592,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#5FBFFF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1_47",
        x1: 0.66,
        x2: 62.333,
        y1: 29.893,
        y2: 29.893,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#68D7FA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#7EF1B3"
    })))));
};

export { SvgCircle as ReactComponent };
//# sourceMappingURL=Circle.svg.es.js.map
